<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21 14a1 1 0 000-2H3a1 1 0 000 2h1v6h-.5a1 1 0 000 2h17a1 1 0 000-2H20v-6zM6.5 20H5v-6h1.5zM9 20H7.5v-6H9zm2.5 0H10v-6h1.5zm2.5 0h-1.5v-6H14zm2.5 0H15v-6h1.5zm2.5 0h-1.5v-6H19zM8 7h3.5v4h1V7H16v4h2V3a1 1 0 00-1-1H7a1 1 0 00-1 1v8h2zm4.5-3H16v2h-3.5zM8 4h3.5v2H8z"/></svg>